module.exports = __webpack_public_path__ + "img/bike3.da07695a.webp";